import { useSyncExternalStore } from 'react';

/**
 * Whether a CSS media query matches, kept live as the window resizes.
 *
 * `useSyncExternalStore` rather than state + effect: the first render already has the right answer
 * (no flash of the desktop layout on a phone), and React re-renders on every change.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/**
 * Phone and small-tablet widths, where the sidebar becomes a slide-over menu. Must match the
 * `max-width: 768px` block in `styles/shell.css`.
 */
export const MOBILE_LAYOUT_QUERY = '(max-width: 768px)';

export function useIsMobileLayout(): boolean {
  return useMediaQuery(MOBILE_LAYOUT_QUERY);
}
